// src/components/transportations/Table/TransportationsTableRow.jsx
import React from "react";
import { TableRow, TableCell, IconButton, Checkbox, Chip, Avatar } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTranslation } from "react-i18next";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";

const TransportationsTableRow = ({
    transportation,
    index,
    isDark,
    page,
    perPage,
    sortBy,
    sortDir,
    totalItems,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    isArchive = false,
    menuDisabled = false,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const serial =
        sortDir === "asc"
            ? (page - 1) * perPage + index + 1
            : (page - 1) * perPage + (totalItems - index);

    const isOdd = index % 2 === 0;
    const isSelected = selectedIds.includes(transportation?.id);

    // Status badge
    const isActive = transportation?.status === "active";
    const statusLabel = isArabic
        ? (isActive ? "نشط" : "معطل")
        : (isActive ? "Active" : "Disabled");

    // Image URL
    const imageUrl = transportation?.image?.url || transportation?.image?.preview || null;

    return (
        <TableRow
            hover
            sx={{
                backgroundColor: isOdd
                    ? isDark
                        ? "rgba(55,65,81,0.45)"
                        : "rgba(249,250,251,0.9)"
                    : "transparent",
            }}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onClick={(e) => onRowCheckboxClick(e, transportation?.id)}
                    inputProps={{ "aria-labelledby": `transportation-${transportation?.id}` }}
                />
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, transportation);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
            <TableCell>{serial}</TableCell>

            <TableCell>
                <Avatar
                    src={imageUrl}
                    alt={transportation?.name?.en || "Transportation"}
                    sx={{
                        width: 48,
                        height: 48,
                        borderRadius: 1,
                        bgcolor: isDark ? "rgba(59,130,246,0.2)" : "rgba(59,130,246,0.1)",
                    }}
                >
                    {!imageUrl && <DirectionsBusIcon />}
                </Avatar>
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {transportation?.name?.ar || "-"}
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {transportation?.name?.en || "-"}
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {transportation?.capacity}
            </TableCell>

            <TableCell>
                <Chip
                    label={statusLabel}
                    size="small"
                    color={isActive ? "success" : "default"}
                    sx={{
                        fontWeight: 500,
                        minWidth: 70,
                    }}
                />
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, transportation);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default TransportationsTableRow;
